import React, { Suspense } from 'react';
import { isMobile } from 'react-device-detect';

const LoadableComp = (props:any) => {
    let pgmPath = props.pgmPath;
    pgmPath = pgmPath.substring(0, 3) + '/' + pgmPath;

    const _props = { ...props.props };
    delete _props.pgmPath;
    delete _props.pullPath;

    let page:any;

    if (!isMobile) {
        page = require.context(
            '../pages/web',
            true,
            /^\.\/(com|frame|usr|hom|cod|pjt|evl)\/.*\.tsx?$/
        );
    } else {
        page = require.context(
            '../pages/mobile',
            true,
            /^\.\/(com|frame|usr|hom|cod|pjt|evl)\/.*\.tsx?$/
        );
    }

    const normalizedPath = React.useMemo(() => {
        return pgmPath ? `./${pgmPath}.tsx` : '';
    }, [pgmPath]);


    const Component = React.useMemo(() => {
        try {
            const LoadedComponent = page(normalizedPath);
            return React.lazy(() =>
                Promise.resolve({
                    default: LoadedComponent.default || LoadedComponent,
                })
            );
        } catch (error) {
            return () => (
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',  // 세로 방향으로 나열
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100vh',
                    textAlign: 'center',
                    fontSize: '20px',
                    color: '#333'
                }}>
                    <div>개발중인 페이지 입니다.</div>
                    <div>완료시까지 AS-IS 페이지를 이용해주세요.</div>
                    <a target="_blank" href="http://intra.withinfo.co.kr:4000" style={{ marginTop: '10px', color: '#007bff', textDecoration: 'none' }}>
                        AS-IS 페이지링크
                    </a>
                </div>
            );
        }
    }, [normalizedPath]);

    return (
        <Suspense fallback={
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                textAlign: 'center',
                fontSize: '20px',
                color: '#333'
            }}>
                로딩 중. . .
            </div>
        }>
            <Component {..._props}/>
        </Suspense>
    );
}

export default LoadableComp;